/**
 * Мінімальний набір SVG-іконок (Aurora) — замість текстових ▾▸↑↓× та емоджі
 * у структурних елементах. Без залежностей: усе inline, stroke=currentColor,
 * тож іконка успадковує колір і розмір тексту (клас `w-4 h-4` тощо).
 *
 * Навмисно вузький набір — додаємо іконку лише коли реально треба, не «про
 * запас» (ponytail).
 */
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 16, className = "", ...rest }: IconProps) {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    className,
    "aria-hidden": true,
    ...rest,
  };
}

export function ChevronDown(p: IconProps) {
  return <svg {...base(p)}><path d="m6 9 6 6 6-6" /></svg>;
}
export function ChevronRight(p: IconProps) {
  return <svg {...base(p)}><path d="m9 6 6 6-6 6" /></svg>;
}
export function ChevronUp(p: IconProps) {
  return <svg {...base(p)}><path d="m6 15 6-6 6 6" /></svg>;
}
/** Подвійна стрілка — стан «не сортовано» у заголовках таблиць. */
export function ChevronsUpDown(p: IconProps) {
  return <svg {...base(p)}><path d="m7 15 5 5 5-5M7 9l5-5 5 5" /></svg>;
}
export function Close(p: IconProps) {
  return <svg {...base(p)}><path d="M18 6 6 18M6 6l12 12" /></svg>;
}
export function Check(p: IconProps) {
  return <svg {...base(p)}><path d="M20 6 9 17l-5-5" /></svg>;
}
export function Search(p: IconProps) {
  return (
    <svg {...base(p)}>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  );
}
export function Warning(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    </svg>
  );
}
